<template>
    <Card>
        <FetchTable :handle="tableHandle" :url="table.url" :columns="table.columns" v-model:orders="table.orders">
            <template #td-name="{row}">
                <router-link :to="{ name: 'EditSupplierPage', params: { supplierUuid: row.uuid } }">{{ row.name }}</router-link>
            </template>
            <template #td-createdAt="{row}">
                {{ DateFormatter.formatDateTime(row.createdAt) }}
            </template>
        </FetchTable>
        <BottomNavbar>
            <ul class="navbar-nav ml-md-auto">
                <li class="nav-item py-1">
                    <AlphaButton color="teal" size="" @click="$refs.modal.show()">
                        <span>{{ $t('buttons.create_new') }}</span>
                    </AlphaButton>
                </li>
            </ul>
        </BottomNavbar>
        <CreateSupplierModal ref="modal" @created="tableHandle.fetchRows()"/>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import BottomNavbar from '../../../../components/new/navbars/FixedBottomNavbar.vue';
import AlphaButton from '../../../../components/new/button/AlphaButton.vue';
import FetchTable from '../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../components/new/table/tableHandle';
import CreateSupplierModal from './modals/CreateSupplierModal.vue';
import DateFormatter from '../../../../services/DateFormatter';
export default {
    name: "IndexSupplierPage",
    components: {
        Card, BottomNavbar, AlphaButton, FetchTable, CreateSupplierModal
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            table: {
                url: '/management/suppliers',
                orders: [],
                columns: [
                    {key: 'id', name: this.$t('table.titles.id'), width: '80px', type: 'string', order: true},
                    {key: 'name', name: this.$t('table.titles.name'), width: 'auto', type: 'string', order: true},
                    {key: 'createdAt', name: this.$t('table.titles.created_at'), width: '200px', type: 'string', order: true},
                ]
            }
        }
    },
    mounted() {
        this.tableHandle.fetchRows()
    }
}
</script>
